import * as React from "react"

export const Logo = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.Ref<SVGSVGElement | null>
  accentColor?: string
}) => {
  const { accentColor } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props} ref={ref}>
      <title>Folo</title>
      <path
        fill={accentColor || "#ff5c00"}
        d="M5.382 0h13.236A5.37 5.37 0 0 1 24 5.383v13.235A5.37 5.37 0 0 1 18.618 24H5.382A5.37 5.37 0 0 1 0 18.618V5.383A5.37 5.37 0 0 1 5.382.001Z"
      />
      <path
        fill="#fff"
        d="M13.269 17.31a1.813 1.813 0 1 0-3.626.002 1.813 1.813 0 0 0 3.626-.002m-.535-6.527H7.213a1.813 1.813 0 1 0 0 3.624h5.521a1.813 1.813 0 1 0 0-3.624m4.417-4.712H8.87a1.813 1.813 0 1 0 0 3.625h8.283a1.813 1.813 0 1 0 0-3.624z"
      />
    </svg>
  )
}
